'use client';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useShowSetting } from '@/src/components//context/ShowSettingProvider.jsx';
import { Img } from '@/src/components/common/ui/images/Img.jsx';
import reactHtmlParser from 'react-html-parser';
import ReactHtmlParser from 'react-html-parser';
import LinkOnly from '@/src/components/common/ui/buttons/LinkOnly.jsx';
import Title from '@/src/components/common/ui/text/Title.jsx';
import Modal from 'react-bootstrap/Modal';
import ModalSlider from '@/src/components/common/eco/sections/modal-slider/ModalSlider.jsx';
import { StyledContactForm } from '@/src/components/common/eco/sections/google-map/google-map.style.js';
import EmailIcon from '@/src/components/common/ui/icons/EmailIcon.jsx';
import PhoneIcon from '@/src/components/common/ui/icons/PhoneIcon.jsx';
import AddressIcon from '@/src/components/common/ui/icons/AddressIcon.jsx';

const ContactForm = ({ data, form_id, interest, asModal, onclick, show, career, topTitle, bottomTitle }) => {
	const settingData = useShowSetting();
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalIsOpenData, setModalIsOpenData] = useState('');
	const [activeMarker, setActiveMarker] = useState(0);





	return (
		<StyledContactForm id={'contact-us'}

		>

			<Container>
				<Row>
					{
						data?.section_data?.subtitle &&
						<Col md={12}>
							<div  className="d-flex justify-content-between">
								<Title
									tag={'h2'}
									margin={'0 0 60px'}
									text={data?.section_data?.subtitle}
									color={'#fff'}
								/>
							</div>
						</Col>

					}


					<Col md={6} className={'pr-0'}>
						{/* Address List */}
						<div data-lenis-prevent data-lenis-prevent-wheel data-lenis-prevent-touch id={'location-address-wrapper'}  className={'location-address-wrapper'}>
							<div className="location">
								<h3>Locations</h3>
							</div>
							<ul>

								{
									data?.posts?.list && data?.posts?.list?.length > 0 &&
									data?.posts?.list?.map((item, index) => {
										const thumb = item?.images?.find((f) => f?.thumb === 'on');
										const officeEmailsRaw = item?.data?.subtitle || '';
										const officeEmails = officeEmailsRaw.split(',').map(e => e.trim()).filter(Boolean);

										const phoneNumbers = [];
										const emailAddresses = [];
										const allImages = item?.images

										officeEmails.forEach((entry) => {
											const cleaned = entry.replace(/[\s\-()]/g, '');
											const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(entry);
											const isPhone = /^\+?(88)?0?\d{9,11}$/.test(cleaned);

											if (isEmail) {
												emailAddresses.push(entry);
											} else if (isPhone) {
												phoneNumbers.push(entry);
											}
										});

										return (
											<li key={item.data.id} // use item.data.id here
												onClick={() => {
													setActiveMarker(item.data.id); // Ensure consistent id usage
												}}
												style={{
													cursor: 'pointer',
													background: activeMarker === item.data?.id ? '#eee' : '#fff',
												}}>

												<div className="image-wrap-button" onClick={(e) => {
													e.preventDefault();
													setModalIsOpenData(item?.images)
													setModalIsOpen(true); // opens modal
												}} >
													<div className="image-wrapper" >
														<Img src={thumb?.full_path} alt={thumb?.short_title || 'Map'} />
													</div>
													<div onClick={(e) => {
														e.preventDefault();
														setModalIsOpenData(item?.images)
														setModalIsOpen(true); // opens modal
													}} className={'click_to_see'}>Click to see more</div>
												</div>
												<div className="content_info">
													<h4>{item?.data?.title}</h4>
													<div className="address">
														<div className="item">
															<div className="icon">
																<AddressIcon/>
															</div>

															{reactHtmlParser(item?.data?.description)}
														</div>


														{/* Phone Numbers Group */}
														{phoneNumbers.length > 0 && (
															<div className="item phone">

																<div className="icon">
																	<PhoneIcon />
																</div>
																<div className="content">
																	{phoneNumbers.map((phone, index) => (
																		<React.Fragment key={index}>
																			<LinkOnly
																				className="email"
																				index={index}
																				color="#fff"
																				src={`tel:${phone.replace(/[\s\-()]/g, '')}`}
																				text={ReactHtmlParser(phone)}
																			/>
																			{index !== phoneNumbers.length - 1 && ', '}
																		</React.Fragment>
																	))}
																</div>
															</div>
														)}

														{/* Email Addresses Group */}
														{emailAddresses.length > 0 && (
															<div className="item email">
																<div className="icon">
																	<EmailIcon />
																</div>

																<div className="content">
																	{emailAddresses.map((email, index) => (
																		<React.Fragment key={index}>
																			<LinkOnly
																				className="email"
																				index={index}
																				color="#fff"
																				src={`mailto:${email}`}
																				text={ReactHtmlParser(email)}
																			/>
																			{index !== emailAddresses.length - 1 && ', '}
																		</React.Fragment>
																	))}
																</div>

															</div>
														)}

													</div>
												</div>
											</li>
										);
									})
								}
							</ul>
						</div >

					</Col>
					<Col md={6} className={'pl-0'}>
						<div className="google-map-wrapper" >
							<div data-id={0} className={`image-wrapper ${activeMarker === 0 ? 'active' : ''} default-map-0`}>
								<Img src={'/images/static/default-map.png'} />
							</div>

							{
								data?.posts?.list && data?.posts?.list?.length > 0 &&
								data?.posts?.list?.map((item, index) => {
									return (
										<div key={index} data-id={item?.data?.id} className={`image-wrapper ${activeMarker === item?.data?.id ? 'active' : ''} default-map-${item?.data?.id}`}>
											{reactHtmlParser(item?.data?.short_desc)}
										</div>
									)
								})
							}


						</div>
					</Col>

				</Row>
			</Container>


			<Modal data={modalIsOpenData} className={'modal-video moda-eco-sourcing'} show={modalIsOpen} onclick={() => {
				setModalIsOpen(false);
			}}>
				<Modal.Body className={'video'}>
					<ModalSlider data={modalIsOpenData} onclick={() => {
						setModalIsOpen(false);
					}} />
				</Modal.Body>

			</Modal>

		</StyledContactForm>
	);
};


export default React.memo(ContactForm);
